import { call, put, takeEvery } from 'redux-saga/effects';

import API from '../../api';
import { PackagesActionTypes } from '../actions/types';
import { ModalsActionCreators, PackagesActionCreators } from '../actions/creators';
import { AsyncActionStatus } from '../enums';
import { generateErrorMessage } from '../helpers';
import { toast } from '../../utilities';

export function* fetchPackageByProjectId(action) {
  try {
    const response = yield call(
      // TODO: Consider about moving this api call from projects to packages
      API.Projects.getPackageByProjectId,
      action.payload.projectId,
    );
    yield put(PackagesActionCreators.fetchPackageByProjectId[AsyncActionStatus.FULFILLED](
      response.data.package,
    ));
  } catch (error) {
    yield put(PackagesActionCreators.fetchPackageByProjectId[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
  }
}

export function* fetchPackageForProofByProjectId(action) {
  try {
    const response = yield call(
      API.Packages.getPackageForProofByProjectId,
      action.payload.projectId,
    );
    yield put(PackagesActionCreators.fetchPackageForProofByProjectId[AsyncActionStatus.FULFILLED](response.data.projectPackage));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(PackagesActionCreators.fetchPackageForProofByProjectId[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
    yield call(toast.error, message);
  }
}

export function* fetchPackageByCustomerId(action) {
  try {
    const response = yield call(
      API.Packages.getPackageByCustomerId,
      action.payload.userId,
    );
    yield put(PackagesActionCreators.fetchPackageByCustomerId[AsyncActionStatus.FULFILLED](
      response.data.projectPackage,
    ));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(PackagesActionCreators.fetchPackageByCustomerId[AsyncActionStatus.REJECTED](
      message,
    ));
    yield call(toast.error, message);
  }
}

export function* getDataForUpgradesByProjectId(action) {
  try {
    const response = yield call(
      API.Packages.getDataForUpgradesByProjectId,
      action.payload.projectId,
    );
    yield put(PackagesActionCreators.getDataForUpgradesByProjectId[AsyncActionStatus.FULFILLED](
      response.data.package,
      response.data.project,
    ));
  } catch (error) {
    yield put(PackagesActionCreators.getDataForUpgradesByProjectId[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
  }
}

export function* upgradePackageRequest(action) {
  try {
    const response = yield call(
      API.Packages.upgradePackageRequest,
      action.payload.projectId,
      action.payload.orders,
    );
    yield put(PackagesActionCreators.upgradePackageRequest[AsyncActionStatus.FULFILLED]());
    yield put(ModalsActionCreators.closePackageUpgradeRequestModal());
    window.location.href = response.data.url;
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(PackagesActionCreators.upgradePackageRequest[AsyncActionStatus.REJECTED](message));
    yield call(toast.error, message);
  }
}

export function* revertUpgradeRequest(action) {
  try {
    yield call(
      API.Packages.revertUpgradeRequest,
      action.payload.projectId,
      action.payload.upgradeRequestId,
    );
    yield put(PackagesActionCreators.revertUpgradeRequest[AsyncActionStatus.FULFILLED]());
  } catch (error) {
    yield put(PackagesActionCreators.revertUpgradeRequest[AsyncActionStatus.REJECTED](
      generateErrorMessage(error),
    ));
  }
}

export function* requestExtensionFeePayment() {
  try {
    const response = yield call(API.Packages.requestExtensionFeePayment);
    yield put(PackagesActionCreators.requestExtensionFeePayment[AsyncActionStatus.FULFILLED]());
    yield put(ModalsActionCreators.closeExtensionFeePaymentModal());
    window.location.href = response.data.url;
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(PackagesActionCreators.requestExtensionFeePayment[AsyncActionStatus.REJECTED](message));
    yield call(toast.error, message);
  }
}

export default [
  takeEvery(
    PackagesActionTypes.fetchPackageByProjectId[AsyncActionStatus.PENDING],
    fetchPackageByProjectId,
  ),
  takeEvery(
    PackagesActionTypes.fetchPackageForProofByProjectId[AsyncActionStatus.PENDING],
    fetchPackageForProofByProjectId,
  ),
  takeEvery(
    PackagesActionTypes.fetchPackageByCustomerId[AsyncActionStatus.PENDING],
    fetchPackageByCustomerId,
  ),
  takeEvery(
    PackagesActionTypes.getDataForUpgradesByProjectId[AsyncActionStatus.PENDING],
    getDataForUpgradesByProjectId,
  ),
  takeEvery(
    PackagesActionTypes.upgradePackageRequest[AsyncActionStatus.PENDING],
    upgradePackageRequest,
  ),
  takeEvery(
    PackagesActionTypes.revertUpgradeRequest[AsyncActionStatus.PENDING],
    revertUpgradeRequest,
  ),
  takeEvery(
    PackagesActionTypes.requestExtensionFeePayment[AsyncActionStatus.PENDING],
    requestExtensionFeePayment,
  ),
];
